import { Zone, Identifiable } from "@planzone/dto";
import { HttpClient, HttpMethods } from "../types/httpClient";

function editZone(httpClient: HttpClient) {
  return ({ uuid }: Identifiable<Zone>, nextZone: Zone) =>
    httpClient.sendHttpRequest<Identifiable<Zone>>({
      endpoint: `/zones/${uuid}`,
      method: HttpMethods.PATCH,
      data: {
        name: nextZone.name,
        description: nextZone.description,
        color: nextZone.color,
      },
    });
}

export { editZone };
